import { useLayoutEffect } from "react";
import { SquareIcon } from "lucide-react";

import { State } from "@/state";

export const COMMAND_ID = "toggle-style-theme";

export type ToggleStyleThemeContextType = Record<string, never>;

export function ToggleStyleThemeCommand() {
  const registerCommandDefinition = State(
    (state) => state.registerCommandDefinition,
  );
  const unregisterCommandDefinition = State(
    (state) => state.unregisterCommandDefinition,
  );

  useLayoutEffect(() => {
    registerCommandDefinition({
      id: COMMAND_ID,
      title: "Toggle Style Theme",
      getTitle: () => {
        const styleTheme = State.getState().styleTheme;
        return styleTheme === "rounded"
          ? "Rounded Theme → Boxy Theme"
          : "Boxy Theme → Rounded Theme";
      },
      description: "Toggle the interface corner style",
      onClick: () => {
        const styleTheme = State.getState().styleTheme;
        State.getState().setStyleTheme(
          styleTheme === "rounded" ? "boxy" : "rounded",
        );
        State.getState().clearCommandStack();
      },
      ReactIcon: SquareIcon,
      group: "Appearance",
    });

    return () => {
      unregisterCommandDefinition(COMMAND_ID);
    };
  }, [registerCommandDefinition, unregisterCommandDefinition]);

  return null;
}
